import { gql } from '@apollo/client';
import { WAREHOUSE_FIELDS, WarehouseType } from 'graphql/types/WarehouseType';

export const CREATE_HUB = gql`
    mutation CreateHub($warehouse: WarehouseTypeInput!) {
        result: createHub(warehouse: $warehouse) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export const CREATE_WAREHOUSE = gql`
    mutation CreateWarehouse($warehouse: WarehouseTypeInput!) {
        result: createWarehouse(warehouse: $warehouse) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export const DISABLE_SITE = gql`
    mutation DisableSite($siteId: Long!) {
        disableSite(siteId: $siteId)
    }
`;

export const SAVE_WAREHOUSE = gql`
    mutation SaveWarehouse($warehouse: WarehouseTypeInput!) {
        result: saveWarehouse(warehouse: $warehouse) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;


export const SAVE_WAREHOUSE_WITH_ZIPCODE_SYNC = gql`
    mutation SaveWarehouseWithZipcodeSync($warehouse: WarehouseTypeInput!) {
        result: saveWarehouseWithZipcodeSync(warehouse: $warehouse) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export const UPDATE_WAREHOUSE_ADDRESS = gql`
    mutation UpdateWarehouseAddress($input: UpdateWarehouseAddressInput!) {
        result: updateWarehouseAddress(input: $input) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export interface WarehouseMutationResponse {
    result: WarehouseType;
}

export interface UpdateWarehouseAddressInput {
    id: number;
    addressLine1: string;
    addressLine2?: string | null;
    country?: string | null;
    state?: string | null;
    city?: string | null;
    zipcode?: string | null;
    location?: {
        latitude: number;
        longitude: number;
    } | null;
}